import React, { useEffect, useState, Component } from 'react';
import Layout from '../../components/Layout';
import { useParams, useNavigate } from 'react-router-dom';
import { GraduationCapIcon, BuildingIcon, CalendarIcon, ClockIcon, UsersIcon, TagIcon, BrainIcon, TrendingUpIcon, AlertCircleIcon, CheckCircleIcon, PencilIcon, TrashIcon, ArrowLeftIcon, SaveIcon, XIcon, SparklesIcon, MapPinIcon, CopyIcon, ArchiveIcon, FileTextIcon, BookOpenIcon, BarChart3Icon, EyeIcon, DownloadIcon, LightbulbIcon, ZapIcon, ChevronRightIcon, ExternalLinkIcon } from 'lucide-react';
// Sample program data - in a real app, this would come from an API
const programsData = [{
  id: 1,
  name: 'Master of Business Administration',
  university: 'UAE Business School',
  universityId: 1,
  type: "Master's",
  duration: '2 Years',
  applications: 48,
  trend: '+12%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-15',
  description: 'Our MBA program is designed to develop the skills required for careers in business and management. The program integrates theoretical and practical knowledge of business with an international perspective.',
  tags: ['High Salary', 'In-Demand'],
  flagged: false,
  healthScore: 92,
  pendingReviews: 8,
  location: 'Dubai',
  curriculum: ['Business Strategy', 'Financial Management', 'Marketing Management', 'Organizational Behavior', 'Operations Management', 'Business Ethics', 'Global Business Environment', 'Leadership and Change Management'],
  admissionRequirements: ["Bachelor's degree from an accredited institution", 'Minimum GPA of 3.0', '2+ years of professional work experience', 'GMAT score of 550+ or equivalent GRE score', 'English proficiency (TOEFL 90+ or IELTS 6.5+)'],
  tuitionFees: '$35,000 total program cost',
  applicationDeadlines: {
    fall: 'May 15, 2023',
    spring: 'October 15, 2023'
  },
  campus: 'Dubai Main Campus',
  deliveryMode: 'In-Person'
}, {
  id: 2,
  name: 'Bachelor of Computer Science',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 112,
  trend: '+28%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-12',
  description: 'The Bachelor of Computer Science program provides students with a comprehensive foundation in computer science principles, programming languages, and software development methodologies. Students will develop technical skills and problem-solving abilities necessary for careers in the rapidly evolving technology sector.',
  tags: ['High Salary', 'In-Demand', 'Fast Completion'],
  flagged: false,
  healthScore: 88,
  pendingReviews: 15,
  location: 'Abu Dhabi',
  curriculum: ['Introduction to Programming', 'Data Structures and Algorithms', 'Database Systems', 'Computer Networks', 'Operating Systems', 'Software Engineering', 'Artificial Intelligence', 'Web Development', 'Mobile Application Development', 'Cybersecurity'],
  admissionRequirements: ['High school diploma or equivalent', 'Minimum GPA of 2.5', 'Mathematics proficiency', 'English proficiency (TOEFL 80+ or IELTS 6.0+)'],
  tuitionFees: '$20,000 per year',
  applicationDeadlines: {
    fall: 'June 30, 2023',
    spring: 'November 30, 2023'
  },
  campus: 'Abu Dhabi Main Campus',
  deliveryMode: 'In-Person'
}, {
  id: 3,
  name: 'Master of Public Administration',
  university: 'UAE Business School',
  universityId: 1,
  type: "Master's",
  duration: '2 Years',
  applications: 27,
  trend: '-5%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-10',
  description: 'The Master of Public Administration program prepares students for leadership roles in government, non-profit organizations, and public service.',
  tags: ['Flexible Schedule'],
  flagged: true,
  healthScore: 75,
  pendingReviews: 6,
  location: 'Dubai',
  curriculum: ['Public Policy Analysis', 'Public Financial Management', 'Public Administration Theory', 'Organizational Leadership', 'Ethics in Public Service', 'Research Methods', 'Strategic Planning', 'Human Resource Management'],
  admissionRequirements: ["Bachelor's degree from an accredited institution", 'Minimum GPA of 3.0', 'Statement of purpose', 'Two letters of recommendation', 'English proficiency (TOEFL 90+ or IELTS 6.5+)'],
  tuitionFees: '$30,000 total program cost',
  applicationDeadlines: {
    fall: 'May 1, 2023',
    spring: 'October 1, 2023'
  },
  campus: 'Dubai Downtown Campus',
  deliveryMode: 'Hybrid'
}, {
  id: 4,
  name: 'PhD in Data Science',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: 'Doctorate',
  duration: '3 Years',
  applications: 15,
  trend: '+8%',
  status: 'Pending Approval',
  skillGap: 'Low',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-05',
  description: 'This doctoral program prepares researchers and professionals to advance the field of data science through original research and innovative applications.',
  tags: ['High Salary', 'In-Demand'],
  flagged: false,
  healthScore: 85,
  pendingReviews: 0,
  location: 'Abu Dhabi',
  curriculum: ['Advanced Machine Learning', 'Statistical Methods for Data Science', 'Big Data Analytics', 'Deep Learning', 'Natural Language Processing', 'Computer Vision', 'Research Methods and Ethics', 'Dissertation'],
  admissionRequirements: ["Master's degree in a relevant field", 'Minimum GPA of 3.5', 'Research proposal', 'Three letters of recommendation', 'Interview', 'English proficiency (TOEFL 100+ or IELTS 7.0+)'],
  tuitionFees: '$15,000 per year',
  applicationDeadlines: {
    fall: 'March 1, 2023',
    spring: 'September 1, 2023'
  },
  campus: 'Abu Dhabi Research Center',
  deliveryMode: 'In-Person'
}, {
  id: 5,
  name: 'Bachelor of Nursing',
  university: 'Dubai Medical College',
  universityId: 4,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 62,
  trend: '+18%',
  status: 'Active',
  skillGap: 'Critical',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-08',
  description: 'The Bachelor of Nursing program prepares students for careers in healthcare with a focus on patient care, health promotion, and disease prevention.',
  tags: ['In-Demand', 'Fast Completion'],
  flagged: true,
  healthScore: 78,
  pendingReviews: 12,
  location: 'Dubai',
  curriculum: ['Anatomy and Physiology', 'Fundamentals of Nursing', 'Pharmacology', 'Medical-Surgical Nursing', 'Pediatric Nursing', 'Maternal-Child Nursing', 'Psychiatric Nursing', 'Community Health Nursing', 'Nursing Leadership and Management', 'Clinical Practicum'],
  admissionRequirements: ['High school diploma or equivalent', 'Minimum GPA of 2.8', 'Science background (Biology, Chemistry)', 'Personal statement', 'Interview', 'English proficiency (TOEFL 85+ or IELTS 6.5+)'],
  tuitionFees: '$18,000 per year',
  applicationDeadlines: {
    fall: 'May 15, 2023',
    spring: 'October 15, 2023'
  },
  campus: 'Dubai Healthcare City',
  deliveryMode: 'In-Person'
}, {
  id: 6,
  name: 'Master of Finance',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Master's",
  duration: '1.5 Years',
  applications: 35,
  trend: '+2%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-07',
  description: 'The Master of Finance program provides advanced knowledge and skills in financial analysis, investment management, and corporate finance.',
  tags: ['High Salary'],
  flagged: false,
  healthScore: 82,
  pendingReviews: 7,
  location: 'Abu Dhabi',
  curriculum: ['Financial Markets and Institutions', 'Investment Analysis', 'Corporate Finance', 'Financial Derivatives', 'Risk Management', 'International Finance', 'Financial Modeling', 'Portfolio Management'],
  admissionRequirements: ["Bachelor's degree from an accredited institution", 'Minimum GPA of 3.0', 'GMAT or GRE score', 'Work experience (preferred)', 'English proficiency (TOEFL 90+ or IELTS 6.5+)'],
  tuitionFees: '$45,000 total program cost',
  applicationDeadlines: {
    fall: 'June 15, 2023',
    spring: 'November 15, 2023'
  },
  campus: 'Abu Dhabi Financial District',
  deliveryMode: 'In-Person'
}, {
  id: 7,
  name: 'Bachelor of Architecture',
  university: 'Sharjah American University',
  universityId: 3,
  type: "Bachelor's",
  duration: '5 Years',
  applications: 45,
  trend: '+5%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-09',
  description: 'The Bachelor of Architecture program prepares students for careers in architectural design, urban planning, and sustainable development.',
  tags: ['High Salary', 'In-Demand'],
  flagged: false,
  healthScore: 90,
  pendingReviews: 9,
  location: 'Sharjah',
  curriculum: ['Architectural Design Studio', 'Building Technology', 'Architectural History and Theory', 'Structural Systems', 'Environmental Systems', 'Urban Planning', 'Digital Design and Fabrication', 'Professional Practice'],
  admissionRequirements: ['High school diploma or equivalent', 'Minimum GPA of 3.0', 'Portfolio of creative work', 'Personal statement', 'English proficiency (TOEFL 85+ or IELTS 6.5+)'],
  tuitionFees: '$22,000 per year',
  applicationDeadlines: {
    fall: 'May 1, 2023',
    spring: 'October 1, 2023'
  },
  campus: 'Sharjah Main Campus',
  deliveryMode: 'In-Person'
}, {
  id: 8,
  name: 'Master of Education',
  university: 'Zayed University',
  universityId: 6,
  type: "Master's",
  duration: '2 Years',
  applications: 28,
  trend: '-3%',
  status: 'Under Review',
  skillGap: 'High',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-03',
  description: 'The Master of Education program prepares educators for leadership roles in schools, universities, and educational organizations.',
  tags: ['Flexible Schedule'],
  flagged: true,
  healthScore: 73,
  pendingReviews: 5,
  location: 'Abu Dhabi',
  curriculum: ['Educational Leadership', 'Curriculum Development', 'Educational Psychology', 'Research Methods in Education', 'Educational Technology', 'Assessment and Evaluation', 'Inclusive Education', 'Educational Policy'],
  admissionRequirements: ["Bachelor's degree from an accredited institution", 'Minimum GPA of 3.0', 'Teaching experience (2+ years preferred)', 'Statement of purpose', 'Two letters of recommendation', 'English proficiency (TOEFL 90+ or IELTS 6.5+)'],
  tuitionFees: '$28,000 total program cost',
  applicationDeadlines: {
    fall: 'April 15, 2023',
    spring: 'September 15, 2023'
  },
  campus: 'Abu Dhabi Education Campus',
  deliveryMode: 'Hybrid'
}];
// Status Badge Component
const StatusBadge = ({
  status
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'Active':
        return 'bg-green-100 text-green-800';
      case 'Under Review':
        return 'bg-yellow-100 text-yellow-800';
      case 'Pending Approval':
        return 'bg-blue-100 text-blue-800';
      case 'Inactive':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor()}`} data-id="element-1331">
      {status}
    </span>;
};
// Trend Indicator Component
const TrendIndicator = ({
  trend
}) => {
  const isPositive = trend.startsWith('+');
  return <span className={`inline-flex items-center ${isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-1332">
      {isPositive ? <TrendingUpIcon className="w-4 h-4 mr-1" data-id="element-1333" /> : <TrendingUpIcon className="w-4 h-4 mr-1 transform rotate-180" data-id="element-1334" />}
      {trend}
    </span>;
};
// Skill Gap Indicator Component
const SkillGapIndicator = ({
  gap
}) => {
  const getGapColor = () => {
    switch (gap) {
      case 'Critical':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'High':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'Medium':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'Low':
        return 'bg-green-100 text-green-800 border-green-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getGapColor()}`} data-id="element-1335">
      {gap}
    </span>;
};
// Health Score Component
const HealthScore = ({
  score
}) => {
  const getBarColor = () => {
    if (score >= 90) return 'bg-green-500';
    if (score >= 80) return 'bg-blue-500';
    if (score >= 70) return 'bg-yellow-500';
    return 'bg-red-500';
  };
  const getTextColor = () => {
    if (score >= 90) return 'text-green-600';
    if (score >= 80) return 'text-blue-600';
    if (score >= 70) return 'text-yellow-600';
    return 'text-red-600';
  };
  const barColorClass = getBarColor();
  const textColorClass = getTextColor();
  const barWidth = `${score}%`;
  return <div className="flex items-center" data-id="element-1336">
      <div className="w-16 h-2 bg-gray-200 rounded-full overflow-hidden mr-2" data-id="element-1337">
        <div className={`h-full ${barColorClass}`} style={{
        width: barWidth
      }} data-id="element-1338"></div>
      </div>
      <span className={`text-sm font-medium ${textColorClass}`} data-id="element-1339">{score}</span>
    </div>;
};
// FAQ Accordion Item
const FAQItem = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-b-0" data-id="element-1340">
      <button className="flex justify-between items-center w-full py-4 text-left font-medium text-gray-900 hover:text-primary-600 focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-1341">
        <span data-id="element-1342">{question}</span>
        <ChevronRightIcon className={`w-5 h-5 text-gray-500 transition-transform ${isOpen ? 'transform rotate-90' : ''}`} data-id="element-1343" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-4' : 'max-h-0'}`} data-id="element-1344">
        <p className="text-gray-600" data-id="element-1345">{answer}</p>
      </div>
    </div>;
};
// Skill badge component
const SkillBadge = ({
  name,
  category
}) => {
  const getCategoryColor = () => {
    switch (category) {
      case 'Technical':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'Soft':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      case 'Industry':
        return 'bg-green-100 text-green-800 border-green-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  return <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-sm border ${getCategoryColor()}`} data-id="element-1346">
      {name}
      <span className="ml-1.5 flex-shrink-0" data-id="element-1347">
        <CheckCircleIcon className="w-3 h-3 text-green-600" data-id="element-1348" />
      </span>
    </span>;
};
const ProgramDetail = () => {
  const {
    programId
  } = useParams();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [program, setProgram] = useState(null);
  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('Overview');
  useEffect(() => {
    // In a real app, this would be an API call
    const fetchProgram = () => {
      setIsLoading(true);
      try {
        const foundProgram = programsData.find(p => p.id === parseInt(programId));
        if (foundProgram) {
          setProgram(foundProgram);
          setFormData(foundProgram);
        } else {
          setError('Program not found');
        }
      } catch (err) {
        setError('Failed to load program details');
      } finally {
        setIsLoading(false);
      }
    };
    fetchProgram();
  }, [programId]);
  const handleInputChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSave = () => {
    // In a real app, this would be an API call to update the program
    setProgram(formData);
    setIsEditing(false);
    // Show success message
    alert('Program updated successfully');
  };
  const handleCancel = () => {
    setFormData(program);
    setIsEditing(false);
  };
  const handleDelete = () => {
    // In a real app, this would be an API call to delete the program
    if (confirm('Are you sure you want to delete this program?')) {
      alert('Program deleted successfully');
      navigate('/admin/programs');
    }
  };
  if (isLoading) return <Layout title="Program Details" persona="Platform Admin" data-id="element-1349">
        <div className="flex justify-center items-center h-64" data-id="element-1350">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500" data-id="element-1351"></div>
        </div>
      </Layout>;
  if (error) return <Layout title="Program Details" persona="Platform Admin" data-id="element-1352">
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative" role="alert" data-id="element-1353">
          <strong className="font-bold" data-id="element-1354">Error: </strong>
          <span className="block sm:inline" data-id="element-1355">{error}</span>
        </div>
      </Layout>;
  if (!program) return <Layout title="Program Details" persona="Platform Admin" data-id="element-1356">
        <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded relative" role="alert" data-id="element-1357">
          <strong className="font-bold" data-id="element-1358">Not Found: </strong>
          <span className="block sm:inline" data-id="element-1359">
            The requested program could not be found.
          </span>
        </div>
      </Layout>;
  return <Layout title={program.name} persona="Platform Admin" data-id="element-1360">
      {/* Back button */}
      <div className="mb-4" data-id="element-1361">
        <button onClick={() => navigate('/admin/programs')} className="flex items-center text-gray-600 hover:text-gray-900 text-sm" data-id="element-1362">
          <ArrowLeftIcon className="w-4 h-4 mr-1" data-id="element-1363" />
          Back to Programs
        </button>
      </div>
      {/* Main content */}
      <div className="space-y-6" data-id="element-1364">
        {/* Program Header */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1365">
          <div className="p-6" data-id="element-1366">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6" data-id="element-1367">
              <div className="flex items-center mb-4 sm:mb-0" data-id="element-1368">
                <div className="h-16 w-16 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center mr-4" data-id="element-1369">
                  <GraduationCapIcon className="h-8 w-8" data-id="element-1370" />
                </div>
                <div data-id="element-1371">
                  <div className="flex items-center" data-id="element-1372">
                    <StatusBadge status={program.status} data-id="element-1373" />
                    <span className="mx-2 text-gray-400" data-id="element-1374">•</span>
                    <span className="text-gray-600" data-id="element-1375">{program.type}</span>
                    <span className="mx-2 text-gray-400" data-id="element-1376">•</span>
                    <span className="text-gray-600" data-id="element-1377">{program.duration}</span>
                  </div>
                  {isEditing ? <input type="text" name="name" value={formData.name} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-xl font-semibold" data-id="element-1378" /> : <h1 className="text-2xl font-semibold text-gray-900 mt-1" data-id="element-1379">
                      {program.name}
                    </h1>}
                  <div className="flex items-center mt-1" data-id="element-1380">
                    <BuildingIcon className="h-4 w-4 text-gray-500 mr-1" data-id="element-1381" />
                    <span className="text-gray-600" data-id="element-1382">{program.university}</span>
                  </div>
                </div>
              </div>
              <div className="flex space-x-2" data-id="element-1383">
                {isEditing ? <>
                    <button onClick={handleSave} className="px-4 py-2 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600" data-id="element-1384">
                      <SaveIcon className="w-4 h-4 mr-1 inline" data-id="element-1385" />
                      Save
                    </button>
                    <button onClick={handleCancel} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1386">
                      <XIcon className="w-4 h-4 mr-1 inline" data-id="element-1387" />
                      Cancel
                    </button>
                  </> : <>
                    <button onClick={() => setIsEditing(true)} className="px-4 py-2 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600" data-id="element-1388">
                      <PencilIcon className="w-4 h-4 mr-1 inline" data-id="element-1389" />
                      Edit
                    </button>
                    <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1390">
                      <CopyIcon className="w-4 h-4 mr-1 inline" data-id="element-1391" />
                      Duplicate
                    </button>
                    <button onClick={handleDelete} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1392">
                      <TrashIcon className="w-4 h-4 mr-1 inline" data-id="element-1393" />
                      Delete
                    </button>
                  </>}
              </div>
            </div>
            {/* Program description */}
            {isEditing ? <div className="mb-6" data-id="element-1394">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1395">
                  Description
                </label>
                <textarea name="description" value={formData.description} onChange={handleInputChange} rows={4} className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500" data-id="element-1396" />
              </div> : <p className="text-gray-700 mb-6" data-id="element-1397">{program.description}</p>}
            {/* Program meta information */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-1398">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1399">
                <div className="text-sm text-gray-500 mb-1" data-id="element-1400">University</div>
                <div className="text-lg font-medium" data-id="element-1401">{program.university}</div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1402">
                <div className="text-sm text-gray-500 mb-1" data-id="element-1403">Location</div>
                <div className="text-lg font-medium" data-id="element-1404">{program.location}</div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1405">
                <div className="text-sm text-gray-500 mb-1" data-id="element-1406">Health Score</div>
                <div className="text-lg font-medium flex items-center" data-id="element-1407">
                  <HealthScore score={program.healthScore} data-id="element-1408" />
                </div>
              </div>
            </div>
            {/* Program tabs */}
            <div className="border-b border-gray-200" data-id="element-1409">
              <nav className="-mb-px flex space-x-8" data-id="element-1410">
                {['Overview', 'Learning Outcomes', 'Admission Requirements', 'Skills & Competencies', 'Enrollment Form', 'Documents'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === tab ? 'border-primary-500 text-primary-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1411">
                    {tab}
                  </button>)}
              </nav>
            </div>
          </div>
        </div>
        {/* Tab content */}
        {activeTab === 'Overview' && <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1412">
            <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-1413">
              Program Overview
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-1414">{program.description}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1415">
              <div data-id="element-1416">
                <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-1417">
                  Delivery Mode
                </h4>
                <p className="text-gray-800" data-id="element-1418">{program.deliveryMode}</p>
              </div>
              <div data-id="element-1419">
                <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-1420">
                  Duration
                </h4>
                <p className="text-gray-800" data-id="element-1421">{program.duration}</p>
              </div>
              <div data-id="element-1422">
                <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-1423">
                  Accreditation
                </h4>
                <p className="text-gray-800" data-id="element-1424">
                  Accredited by the Ministry of Education
                </p>
              </div>
              <div data-id="element-1425">
                <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-1426">
                  Campus Location
                </h4>
                <p className="text-gray-800" data-id="element-1427">{program.campus}</p>
              </div>
            </div>
            <div className="mb-6" data-id="element-1428">
              <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-1429">
                Target Audience
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-1430">
                <span className="bg-primary-50 text-primary-700 px-3 py-1 rounded-full text-sm" data-id="element-1431">
                  Recent Graduates
                </span>
                <span className="bg-primary-50 text-primary-700 px-3 py-1 rounded-full text-sm" data-id="element-1432">
                  Career Changers
                </span>
                <span className="bg-primary-50 text-primary-700 px-3 py-1 rounded-full text-sm" data-id="element-1433">
                  Working Professionals
                </span>
              </div>
            </div>
            <div className="mb-6" data-id="element-1434">
              <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-1435">
                Tuition & Fees
              </h4>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 mb-4" data-id="element-1436">
                <div className="flex items-center justify-between" data-id="element-1437">
                  <div data-id="element-1438">
                    <p className="text-gray-600 text-sm" data-id="element-1439">Total Program Cost</p>
                    <p className="text-xl font-semibold text-gray-900" data-id="element-1440">
                      {program.tuitionFees}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-500" data-id="element-1441">
                * Additional fees may apply for textbooks, materials, and
                student services.
              </p>
            </div>
            <div className="mb-6" data-id="element-1442">
              <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-1443">
                Application Statistics
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1444">
                <div className="border border-gray-200 rounded-md p-4" data-id="element-1445">
                  <div className="flex items-center" data-id="element-1446">
                    <div className="p-2 bg-primary-50 rounded-full mr-3" data-id="element-1447">
                      <UsersIcon className="h-5 w-5 text-primary-500" data-id="element-1448" />
                    </div>
                    <div data-id="element-1449">
                      <div className="text-2xl font-semibold" data-id="element-1450">
                        {program.applications}
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-1451">Applications</div>
                    </div>
                  </div>
                </div>
                <div className="border border-gray-200 rounded-md p-4" data-id="element-1452">
                  <div className="flex items-center" data-id="element-1453">
                    <div className="p-2 bg-primary-50 rounded-full mr-3" data-id="element-1454">
                      <TrendingUpIcon className="h-5 w-5 text-primary-500" data-id="element-1455" />
                    </div>
                    <div data-id="element-1456">
                      <div className="text-2xl font-semibold" data-id="element-1457">
                        <TrendIndicator trend={program.trend} data-id="element-1458" />
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-1459">
                        Application Trend
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border border-gray-200 rounded-md p-4" data-id="element-1460">
                  <div className="flex items-center" data-id="element-1461">
                    <div className="p-2 bg-primary-50 rounded-full mr-3" data-id="element-1462">
                      <BrainIcon className="h-5 w-5 text-primary-500" data-id="element-1463" />
                    </div>
                    <div data-id="element-1464">
                      <div className="flex items-center" data-id="element-1465">
                        <SkillGapIndicator gap={program.skillGap} data-id="element-1466" />
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-1467">Skill Gap</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-6" data-id="element-1468">
              <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-1469">
                Health Score
              </h4>
              <div className="flex items-center" data-id="element-1470">
                <div className="p-2 bg-gray-50 rounded-md" data-id="element-1471">
                  <HealthScore score={program.healthScore} data-id="element-1472" />
                </div>
                <span className="ml-2 text-gray-600" data-id="element-1473">Program Health</span>
              </div>
            </div>
            <div className="mb-6" data-id="element-1474">
              <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-1475">
                AI Recommendations
              </h4>
              <div className="p-4 bg-primary-50 border border-primary-100 rounded-lg" data-id="element-1476">
                <div className="flex items-start" data-id="element-1477">
                  <SparklesIcon className="w-5 h-5 text-primary-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1478" />
                  <div data-id="element-1479">
                    <p className="text-sm text-primary-700" data-id="element-1480">
                      {program.skillGap === 'Critical' || program.skillGap === 'High' ? `We recommend a comprehensive curriculum review for this program. Consider incorporating ${program.name.includes('Business') ? 'digital transformation, data analytics, and sustainable business practices' : program.name.includes('Computer') ? 'cloud computing, cybersecurity, and artificial intelligence' : program.name.includes('Nursing') ? 'telehealth technologies, pandemic preparedness, and healthcare informatics' : 'emerging industry practices and technologies'} to address current skill gaps.` : program.trend.startsWith('-') ? `Consider refreshing marketing materials and outreach strategies to highlight program strengths and career outcomes. Engage with industry partners to ensure program visibility and relevance.` : `This program is performing well. Continue monitoring market trends and consider minor curriculum updates to maintain alignment with industry needs.`}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>}
        {activeTab === 'Learning Outcomes' && <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1481">
            <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-1482">
              Learning Outcomes
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-1483">
              Upon successful completion of this program, students will be able
              to:
            </p>
            {isEditing ? <textarea name="curriculum" value={formData.curriculum ? formData.curriculum.join('\n') : ''} onChange={e => setFormData({
          ...formData,
          curriculum: e.target.value.split('\n').filter(item => item.trim() !== '')
        })} rows={8} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500" placeholder="Enter each curriculum item on a new line" data-id="element-1484" /> : <div className="space-y-4" data-id="element-1485">
                {program.curriculum && program.curriculum.map((item, index) => <div key={index} className="flex items-start" data-id="element-1486">
                      <div className="flex-shrink-0 mt-1" data-id="element-1487">
                        <div className="w-6 h-6 flex items-center justify-center text-primary-600" data-id="element-1488">
                          <CheckCircleIcon className="w-4 h-4" data-id="element-1489" />
                        </div>
                      </div>
                      <p className="ml-4 text-gray-700" data-id="element-1490">{item}</p>
                    </div>)}
              </div>}
          </div>}
        {activeTab === 'Admission Requirements' && <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1491">
            <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-1492">
              Admission Requirements
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-1493">
              Applicants to this program must meet the following requirements:
            </p>
            {isEditing ? <textarea name="admissionRequirements" value={formData.admissionRequirements ? formData.admissionRequirements.join('\n') : ''} onChange={e => setFormData({
          ...formData,
          admissionRequirements: e.target.value.split('\n').filter(item => item.trim() !== '')
        })} rows={8} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500" placeholder="Enter each requirement on a new line" data-id="element-1494" /> : <div className="space-y-4" data-id="element-1495">
                {program.admissionRequirements && program.admissionRequirements.map((item, index) => <div key={index} className="flex items-start" data-id="element-1496">
                      <div className="flex-shrink-0 mt-1" data-id="element-1497">
                        <div className="w-6 h-6 flex items-center justify-center text-primary-600" data-id="element-1498">
                          <CheckCircleIcon className="w-4 h-4" data-id="element-1499" />
                        </div>
                      </div>
                      <p className="ml-4 text-gray-700" data-id="element-1500">{item}</p>
                    </div>)}
              </div>}
          </div>}
        {activeTab === 'Skills & Competencies' && <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1501">
            <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-1502">
              Skills & Competencies
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-1503">
              Students will develop the following skills through this program:
            </p>
            <div className="space-y-6" data-id="element-1504">
              {/* Technical Skills */}
              <div data-id="element-1505">
                <div className="flex items-center mb-3" data-id="element-1506">
                  <BrainIcon className="w-5 h-5 text-blue-600 mr-2" data-id="element-1507" />
                  <h3 className="font-medium text-gray-800" data-id="element-1508">
                    Technical Skills
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-1509">
                  <SkillBadge name="Programming" category="Technical" data-id="element-1510" />
                  <SkillBadge name="Data Structures" category="Technical" data-id="element-1511" />
                  <SkillBadge name="Algorithms" category="Technical" data-id="element-1512" />
                  <SkillBadge name="Database Management" category="Technical" data-id="element-1513" />
                </div>
              </div>
              {/* Soft Skills */}
              <div data-id="element-1514">
                <div className="flex items-center mb-3" data-id="element-1515">
                  <LightbulbIcon className="w-5 h-5 text-purple-600 mr-2" data-id="element-1516" />
                  <h3 className="font-medium text-gray-800" data-id="element-1517">Soft Skills</h3>
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-1518">
                  <SkillBadge name="Problem Solving" category="Soft" data-id="element-1519" />
                  <SkillBadge name="Critical Thinking" category="Soft" data-id="element-1520" />
                  <SkillBadge name="Teamwork" category="Soft" data-id="element-1521" />
                </div>
              </div>
              {/* Industry Skills */}
              <div data-id="element-1522">
                <div className="flex items-center mb-3" data-id="element-1523">
                  <ZapIcon className="w-5 h-5 text-green-600 mr-2" data-id="element-1524" />
                  <h3 className="font-medium text-gray-800" data-id="element-1525">
                    Industry-specific Skills
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-1526">
                  <SkillBadge name="Software Development" category="Industry" data-id="element-1527" />
                  <SkillBadge name="Web Development" category="Industry" data-id="element-1528" />
                  <SkillBadge name="Mobile App Development" category="Industry" data-id="element-1529" />
                </div>
              </div>
            </div>
            {/* AI-generated summary */}
            <div className="mt-8 p-4 bg-blue-50 border border-blue-100 rounded-lg" data-id="element-1530">
              <div className="flex items-start" data-id="element-1531">
                <SparklesIcon className="w-5 h-5 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1532" />
                <div data-id="element-1533">
                  <h3 className="font-medium text-blue-800 mb-1" data-id="element-1534">
                    AI-Generated Insight
                  </h3>
                  <p className="text-sm text-blue-700" data-id="element-1535">
                    This program is highly aligned with UAE labor market trends.
                    The combination of Programming and Problem Solving skills is
                    in high demand across multiple industries.
                  </p>
                </div>
              </div>
            </div>
          </div>}
        {activeTab === 'Enrollment Form' && <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1536">
            <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-1537">
              Enrollment Form
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-1538">
              The following fields are included in the student application form:
            </p>
            <div className="overflow-hidden border border-gray-200 rounded-lg mb-6" data-id="element-1539">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-1540">
                <thead className="bg-gray-50" data-id="element-1541">
                  <tr data-id="element-1542">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1543">
                      Field Label
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1544">
                      Type
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1545">
                      Required
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1546">
                      Eligibility Field
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-1547">
                  <tr data-id="element-1548">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1549">
                      Full Name
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize" data-id="element-1550">
                      text
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1551">
                      <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-1552" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1553">
                      <span className="text-gray-400" data-id="element-1554">No</span>
                    </td>
                  </tr>
                  <tr data-id="element-1555">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1556">
                      Email Address
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize" data-id="element-1557">
                      email
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1558">
                      <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-1559" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1560">
                      <span className="text-gray-400" data-id="element-1561">No</span>
                    </td>
                  </tr>
                  <tr className="bg-green-50" data-id="element-1562">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1563">
                      High School GPA
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize" data-id="element-1564">
                      number
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1565">
                      <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-1566" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1567">
                      <div className="flex items-center" data-id="element-1568">
                        <CheckCircleIcon className="w-5 h-5 text-green-500 mr-1" data-id="element-1569" />
                        <span className="text-green-700 font-medium" data-id="element-1570">Yes</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="flex justify-between items-center" data-id="element-1571">
              <div className="text-sm text-gray-500" data-id="element-1572">
                <span className="inline-block w-3 h-3 bg-green-50 border border-green-100 rounded-sm mr-1" data-id="element-1573"></span>
                Highlighted rows are used for eligibility screening
              </div>
              <button className="bg-white text-primary-600 border border-primary-200 px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-50 transition-colors flex items-center" data-id="element-1574">
                <ExternalLinkIcon className="w-4 h-4 mr-2" data-id="element-1575" />
                Preview Student Form
              </button>
            </div>
          </div>}
        {activeTab === 'Documents' && <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1576">
            <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-1577">
              Attached Documents
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-1578">
              The following documents have been uploaded for this program:
            </p>
            <div className="space-y-4" data-id="element-1579">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-100" data-id="element-1580">
                <div className="flex items-center" data-id="element-1581">
                  <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center mr-4" data-id="element-1582">
                    <FileTextIcon className="w-5 h-5 text-gray-600" data-id="element-1583" />
                  </div>
                  <div data-id="element-1584">
                    <p className="font-medium text-gray-800" data-id="element-1585">
                      Program Brochure.pdf
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-1586">
                      PDF • 2.4 MB • Uploaded on 2023-05-15
                    </p>
                  </div>
                </div>
                <div className="flex space-x-2" data-id="element-1587">
                  <button className="p-2 text-gray-600 hover:text-gray-800 rounded-full hover:bg-gray-200" data-id="element-1588">
                    <EyeIcon className="w-5 h-5" data-id="element-1589" />
                  </button>
                  <button className="p-2 text-gray-600 hover:text-gray-800 rounded-full hover:bg-gray-200" data-id="element-1590">
                    <DownloadIcon className="w-5 h-5" data-id="element-1591" />
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-100" data-id="element-1592">
                <div className="flex items-center" data-id="element-1593">
                  <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center mr-4" data-id="element-1594">
                    <FileTextIcon className="w-5 h-5 text-gray-600" data-id="element-1595" />
                  </div>
                  <div data-id="element-1596">
                    <p className="font-medium text-gray-800" data-id="element-1597">
                      Course Catalog.pdf
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-1598">
                      PDF • 3.8 MB • Uploaded on 2023-05-20
                    </p>
                  </div>
                </div>
                <div className="flex space-x-2" data-id="element-1599">
                  <button className="p-2 text-gray-600 hover:text-gray-800 rounded-full hover:bg-gray-200" data-id="element-1600">
                    <EyeIcon className="w-5 h-5" data-id="element-1601" />
                  </button>
                  <button className="p-2 text-gray-600 hover:text-gray-800 rounded-full hover:bg-gray-200" data-id="element-1602">
                    <DownloadIcon className="w-5 h-5" data-id="element-1603" />
                  </button>
                </div>
              </div>
            </div>
          </div>}
        {/* Editing controls */}
        {isEditing && <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 flex justify-end space-x-4" data-id="element-1604">
            <button onClick={handleCancel} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1605">
              <XIcon className="w-4 h-4 mr-1 inline" data-id="element-1606" />
              Cancel
            </button>
            <button onClick={handleSave} className="px-4 py-2 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600" data-id="element-1607">
              <SaveIcon className="w-4 h-4 mr-1 inline" data-id="element-1608" />
              Save Changes
            </button>
          </div>}
      </div>
    </Layout>;
};
export default ProgramDetail;